export const galleryImages = [
    { image: "../images/home/gallery/1.jpg", caption: "A discreet arrival experience" },
    { image: "../images/home/gallery/reception.jpg", caption: "Brand new reception area" },
    { image: "../images/home/gallery/3.jpg", caption: "State-of-the-art end-of trip facilities" },
    { image: "../images/home/gallery/4.jpg", caption: "A stunning landscaped courtyard" },
    { image: "../images/home/gallery/5.jpg", caption: "Beautiful roof terraces" },
    { image: "../images/home/gallery/6.jpg", caption: "In the heart of Marylebone" },
];
